import { forwardRef } from 'react'
import clsx from 'clsx'
import { IImageProps } from './types'
import styles from './styles.module.scss'

export const Image = forwardRef<HTMLImageElement, IImageProps>(
  (
    {
      alt,
      borderRadius = 0,
      caption,
      className,
      height = 'auto',
      objectFit = 'initial',
      objectPosition = 'initial',
      width = 'auto',
      ...props
    },
    ref,
  ) => (
    <picture
      className={clsx('mui-image', styles.picture)}
      style={{ borderRadius: borderRadius, height: height, width: width }}
    >
      <img
        alt={alt}
        ref={ref}
        className={clsx(
          styles[objectFit],
          styles[`objectPosition-${objectPosition.replace(/\s/g, '')}`],
          className,
        )}
        {...props}
      />
      {caption && (
        <figcaption className={`caption-14-regular ${styles.caption}`}>{caption}</figcaption>
      )}
    </picture>
  ),
)

export default Image
